import * as Sentry from '@sentry/react';
import { FC, ReactNode } from 'react';

import { CommonRecoveryFallback } from './common-recovery-fallback';

interface Props {
  children: ReactNode;
  fallback?: Sentry.FallbackRender;
}

export const CommonErrorBoundary: FC<Props> = ({ children, fallback = <CommonRecoveryFallback /> }) => (
  <Sentry.ErrorBoundary fallback={fallback}>{children}</Sentry.ErrorBoundary>
);
